import { Job, JobApplication } from '@core/generated/gql-types';
import {
  TemplateTerm,
  useTemplateStore,
} from '@core/template/useTemplateStore';

interface SelectWorkerHeaderProps {
  job: Job;
  jobApplications: JobApplication[] | null;
  setOpenWorkerSearchModal: (open: boolean) => void;
  openWorkerSearchModal: boolean;
  /** When false, hide free-search assign (applicants-only / client portal). */
  allowWorkerSearch?: boolean;
}

const SelectWorkerHeader = ({
  job,
  jobApplications,
  setOpenWorkerSearchModal,
  openWorkerSearchModal,
  allowWorkerSearch = true,
}: SelectWorkerHeaderProps) => {
  const { getTerm } = useTemplateStore();
  return (
    <div className="mb-3 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <h3 className="text-sm font-semibold text-gray-900">
          {job.workersShouldApplyToJob
            ? getTerm(TemplateTerm.WORKER, true)
            : getTerm(TemplateTerm.WORKER, false)}
        </h3>
        {jobApplications && jobApplications.length > 0 && (
          <p className="text-sm text-gray-600">
            {`(${jobApplications.length} applied)`}
          </p>
        )}
      </div>

      {allowWorkerSearch && (
        <button
          type="button"
          onClick={() => {
            setOpenWorkerSearchModal(!openWorkerSearchModal);
          }}
          className="cursor-pointer text-sm font-medium text-blue-600 hover:text-blue-800"
        >
          {!openWorkerSearchModal &&
            `Show matching ${getTerm(TemplateTerm.WORKER, true).toLowerCase()}`}
        </button>
      )}
    </div>
  );
};

export default SelectWorkerHeader;
